exports.f = Object.getOwnPropertySymbols;



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-polyfill/~/core-js/modules/_object-gops.js
 ** module id = 70
 ** module chunks = 2 4 5 7
 **/